import axios from "axios";
import server from "../config/address";

const headers = {};
Object.defineProperty(headers, "authorization", {
	get() { return localStorage.getItem("token"); },
	enumerable: true,
	configurable: true,
});
Object.defineProperty(headers, "x-venue-id", {
	get() { return localStorage.getItem("venueId") || ""; },
	enumerable: true,
	configurable: true,
});

// Intercepteur global 401 — redirige vers la page de login si le token est expiré
axios.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 401) {
			localStorage.removeItem('token');
			localStorage.removeItem('venue');
			localStorage.removeItem('venueId');
			if (window.location.pathname !== '/') {
				window.location.replace('/');
			}
		}
		return Promise.reject(error);
	}
);

/**
 * Function used for authentication
 */
async function login(userCredentials) {
	try {
		let results = await axios.post(`${server.url}/admin/login`, {
			phone: userCredentials.phone,
			password: userCredentials.password,
		});
		localStorage.setItem("token", results.data.token);
		return results.data.token || results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * Used for registration of admin users (SECRETAIRE & COACH)
 */
async function register(userDetails) {
	try {
		let results = await axios.post(
			`${server.url}/admin/register`,
			userDetails
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * Get specific type of users
 */
async function getSpecificUsers(userType) {
	try {
		let results = await axios.get(`${server.url}/admin/type/${userType}`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * Get sponsorships
 */
async function getSponsorships() {
	try {
		let results = await axios.get(`${server.url}/customer/sponsorships`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * Get all customers
 */
async function getClients() {
	try {
		let results = await axios.get(`${server.url}/customer/all`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function searchClients(query) {
	try {
		let results = await axios.get(`${server.url}/customer/search`, { headers, params: { q: query, limit: 10 } });
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getClient(clientId) {
	try {
		let results = await axios.get(
			`${server.url}/customer/dashboard/${clientId}`,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * Retrieve all subscriptions
 */
async function getSubscriptions() {
	try {
		let results = await axios.get(`${server.url}/subscription/`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * Get one specified subscription
 */
async function getSingleSubscription(subscriptionId) {
	try {
		let results = await axios.get(
			`${server.url}/subscription/${subscriptionId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * Retrieve customer subscription
 */
async function getCustomerSubscription(customerId) {
	try {
		let results = await axios.get(
			`${server.url}/subscription/customer/${customerId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Modifiy subscription details */
async function updateSubscription(subscriptionId, subscriptionDetails) {
	try {
		let results = await axios.put(
			`${server.url}/subscription/${subscriptionId}`,
			{ subscriptionDetails },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Delete a single subscription */
async function deleteSubscription(subscriptionId) {
	try {
		let results = await axios.delete(
			`${server.url}/subscription/${subscriptionId}`,
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Create a new subscription */
async function createSubscription(subscriptionDetails) {
	try {
		let results = await axios.post(
			`${server.url}/subscription`,
			subscriptionDetails,
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Attribute a subscription to a customer */
async function attributionSubscription(
	subscriptionId,
	customerId,
	subscriptionDate
) {
	try {
		let results = await axios.put(
			`${server.url}/subscription/${subscriptionId}/customer/${customerId}`,
			{ subscriptionDate },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function updateInscription(customerId, registered) {
	try {
		let results = await axios.put(
			`${server.url}/customer/${customerId}/inscription`,
			{ registered },
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * FOOD REQUESTS
 */
/** Create a new food */
async function createFood(foodDetails) {
	try {
		let results = await axios.post(
			`${server.url}/food`,
			{ foodDetails },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Get all foods */
async function getFoods() {
	try {
		let results = await axios.get(`${server.url}/food`, { headers });
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Get all foods */
async function getFoodsAttributions() {
	try {
		let results = await axios.get(`${server.url}/food/attributions`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Get customer foods */
async function getCustomerFood(customerId) {
	try {
		let results = await axios.get(
			`${server.url}/food/admin/customer/${customerId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function foodImageUpload(image) {
	try {
		let results = await axios.put(`${server.url}/food/image`, image);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Delete single food */
async function deleteFood(foodId) {
	try {
		let results = await axios.delete(`${server.url}/food/${foodId}`, {
			headers,
		});
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Update single food */
async function updateFood(foodId, foodDetails) {
	try {
		let results = await axios.put(
			`${server.url}/food/${foodId}`,
			{
				foodDetails,
			},
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Attribute food to a customer */
async function attributeFood(customers, foodId, period) {
	try {
		let results = await axios.put(
			`${server.url}/food/${foodId}/customers/`,
			{ period, customers },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Desattribute food to a customer */
async function removeAttribution(attributionId) {
	try {
		let results = await axios.delete(
			`${server.url}/food/attribution/${attributionId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/**
 * FOOD CATEGORIES
 */
async function getFoodCategories() {
	try {
		let results = await axios.get(`${server.url}/food/categories`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function createFoodCategory(foodCategory) {
	try {
		let results = await axios.post(
			`${server.url}/food/category`,
			foodCategory,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}
async function updateFoodCategory(foodCategoryId, foodCategory) {
	try {
		let results = await axios.put(
			`${server.url}/food/category/${foodCategoryId}`,
			foodCategory,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}
async function deleteFoodCategory(foodCategoryId) {
	try {
		let results = await axios.delete(
			`${server.url}/food/category/${foodCategoryId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** PROTOCOLS REQUESTS */
/** Create a new protocol */
async function createProcotol(protocolDetails) {
	try {
		let results = await axios.post(
			`${server.url}/protocol`,
			{ protocolDetails },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function updateProcotol(protocolId, protocolDetails) {
	try {
		let results = await axios.put(
			`${server.url}/protocol/update/${protocolId}/`,
			{ protocolDetails },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getProtocols() {
	try {
		let results = await axios.get(`${server.url}/protocol`, { headers });
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getProtocol(customerId) {
	try {
		let results = await axios.get(
			`${server.url}/protocol/customer/${customerId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function deleteProtocol(protocolId) {
	try {
		let results = await axios.delete(
			`${server.url}/protocol/${protocolId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function endProtocol(attributionId) {
	try {
		let results = await axios.delete(
			`${server.url}/protocol/attribution/${attributionId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function singleProtocolAttribution(protocolId, customerProtocols) {
	try {
		let results = await axios.post(
			`${server.url}/protocol/${protocolId}/customer`,
			{ customerProtocols },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function multiProtocolAttribution(customerId, protocolIds) {
	try {
		let results = await axios.post(
			`${server.url}/protocol/multi-attribution/customer/${customerId}`,
			{ protocolIds },
			{ headers }
		);
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getCustomerProtocols(customerId) {
	try {
		let results = await axios.get(
			`${server.url}/protocol/customer/${customerId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** EXERCISE MANAGEMENT
 *
 * Get all exercises
 */
async function getExercises() {
	try {
		let results = await axios.get(`${server.url}/exercice`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** EXERCISE MANAGEMENT
 *
 * Add an exercise one at a time
 */
async function addExercise(exercise) {
	try {
		let results = await axios.post(`${server.url}/exercice`, exercise, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** EXERCISE MANAGEMENT
 *
 * Update an exercise
 */
async function updateExercise(exerciseId, exercise) {
	try {
		let results = await axios.put(
			`${server.url}/exercice/${exerciseId}`,
			exercise,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** EXERCISE MANAGEMENT
 *
 * Delete an exercise
 */
async function deleteExercise(exerciseId) {
	try {
		let results = await axios.delete(
			`${server.url}/exercice/${exerciseId}`,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** EXERCISE MANAGEMENT
 *
 * Synchronize an exercise with a protocol
 */
async function syncExerciseWithProtocol(exerciseIds, protocolId) {
	try {
		let results = await axios.post(
			`${server.url}/exercice/protocol/${protocolId}`,
			{ exercices: exerciseIds },
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** EXERCISE MANAGEMENT
 *
 * Desynchronize an exercise with a protocol
 */
async function removeExerciseToProtocol(protocolId, exerciseId) {
	try {
		let results = await axios.delete(
			`${server.url}/exercice/${exerciseId}/protocol/${protocolId}`,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** EXERCISE MANAGEMENT
 *
 * Get exercise's protocol
 */
async function getProtocolExercises(protocolId) {
	try {
		let results = await axios.get(
			`${server.url}/exercice/protocol/${protocolId}`,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SESSION MANAGEMENT
 *
 * Get sessions
 */
async function getSessions() {
	try {
		let results = await axios.get(`${server.url}/session`, { headers });
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SESSION MANAGEMENT
 *
 * add new session
 */
async function addSession(sessionDetails) {
	try {
		let results = await axios.post(
			`${server.url}/session`,
			sessionDetails,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SESSION MANAGEMENT
 *
 * update session
 */
async function updateSession(sessionId, updatedSessionDetails) {
	try {
		let results = await axios.put(
			`${server.url}/session/${sessionId}`,
			updatedSessionDetails,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SESSION MANAGEMENT
 *
 * delete session
 */
async function deleteSession(sessionId) {
	try {
		let results = await axios.delete(`${server.url}/session/${sessionId}`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SESSION MANAGEMENT | PROGRAMMED SESSION MANAGEMENT
 *
 * Get programmed sessions
 */
async function getProgrammedSessions() {
	try {
		let results = await axios.get(`${server.url}/session/attributions`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SESSION MANAGEMENT | PROGRAMMED SESSION MANAGEMENT
 *
 * add session programmation
 */
async function attributeSession(attributionDetails) {
	try {
		let results = await axios.post(
			`${server.url}/session/attribution`,
			attributionDetails,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SESSION MANAGEMENT | PROGRAMMED SESSION MANAGEMENT
 *
 * delete session attribution
 */
async function deleteProgrammedSession(programmedSessionId) {
	try {
		let results = await axios.delete(
			`${server.url}/session/attribution/${programmedSessionId}`,
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

// Manage presences
async function getPresences() {
	try {
		let results = await axios.get(`${server.url}/presence`, { headers });
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getPresencesPaginated({ page = 1, limit = 10, search = "", salle = "" } = {}) {
	try {
		const params = { page, limit, search };
		if (salle) params.salle = salle;
		let results = await axios.get(`${server.url}/presence`, { headers, params });
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function otp(code) {
	try {
		let results = await axios.post(
			`${server.url}/otp/admin/validate`,
			{ code: code.otp },
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function changeClientStatus(customerId, status) {
	try {
		let results = await axios.put(
			`${server.url}/customer/status/${customerId}`,
			{ validation: status }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getRewards() {
	try {
		let results = await axios.get(`${server.url}/reward`, { headers });
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function attributeReward(customerId, point) {
	try {
		let results = await axios.put(
			`${server.url}/reward/customer/${customerId}`,
			{ point },
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function addReward(reward) {
	try {
		let results = await axios.post(
			`${server.url}/reward`,
			{ rewardDetails: reward },
			{ headers }
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** FAQ MANAGEMENT
 *
 * Get FAQs
 */
async function getQuestions() {
	try {
		let results = await axios.get(`${server.url}/faq`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** FAQ MANAGEMENT
 *
 * Add question/answer
 */
async function addQuestionAnswer(questionAnswer) {
	try {
		let results = await axios.post(`${server.url}/faq`, questionAnswer, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** FAQ MANAGEMENT
 *
 * Update question/answer
 */
async function updateQuestionAnswer(questionAnswer, questionAnswerId) {
	try {
		let results = await axios.put(
			`${server.url}/faq/${questionAnswerId}`,
			questionAnswer,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** FAQ MANAGEMENT
 *
 * Delete question/answer
 */
async function deleteQuestionAnswer(questionAnswerId) {
	try {
		let results = await axios.delete(
			`${server.url}/faq/${questionAnswerId}`,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** TRANSACTIONS MANAGEMENT
 *
 * Create new payment
 */
async function createPayment(paymentDetails) {
	try {
		let results = await axios.post(
			`${server.url}/transaction/pay`,
			paymentDetails,
			{
				headers,
			}
		);
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** TRANSACTIONS MANAGEMENT
 *
 * Get all transactions
 */
async function getTransactions() {
	try {
		let results = await axios.get(`${server.url}/transaction/`, {
			headers,
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** SERVER-SIDE PAGINATED VERSIONS — used by the 5 main data tables */

async function getClientsPaginated({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/customer/all`, {
			headers,
			params: { page, limit, search },
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getFoodsPaginated({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/food`, {
			headers,
			params: { page, limit, search },
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getSubscriptionsPaginated({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/subscription/`, {
			headers,
			params: { page, limit, search },
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getSponsorshipsPaginated({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/customer/sponsorships`, {
			headers,
			params: { page, limit, search },
		});
		return results.data;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

async function getProtocolsPaginated({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/protocol`, {
			headers,
			params: { page, limit, search },
		});
		return results;
	} catch (error) {
		console.log(error);
		throw error.response.data;
	}
}

/** Solde définitivement une avance sur abonnement */
async function finalizeAdvance(historyId) {
	try {
		return await axios.patch(`${server.url}/subscription/history/${historyId}/finalize`, {}, { headers });
	} catch (error) {
		console.log(error);
		throw error.response?.data || error;
	}
}

/** Création rapide d'un client sans compte */
async function createQuickCustomer(fullName, phone = null) {
	try {
		return await axios.post(`${server.url}/customer/quick`, { fullName, phone }, { headers });
	} catch (error) {
		console.log(error);
		throw error.response?.data || error;
	}
}

/** ATTRIBUTION AMÉLIORÉE (remise + inscription) */
async function attributionSubscriptionEnhanced(subscriptionId, customerId, subscriptionDate, registered, discount, amountPaid) {
	try {
		const body = { subscriptionDate, registered, discount };
		if (amountPaid !== null && amountPaid !== undefined) body.amountPaid = amountPaid;
		let results = await axios.put(
			`${server.url}/subscription/${subscriptionId}/customer/${customerId}`,
			body,
			{ headers }
		);
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** ATTRIBUTION GROUPÉE */
async function attributionSubscriptionBulk(subscriptionId, customerIds, subscriptionDate, registered, discount, amountPaid) {
	try {
		const body = { customerIds, subscriptionDate, registered, discount };
		if (amountPaid !== null && amountPaid !== undefined) body.amountPaid = amountPaid;
		let results = await axios.post(
			`${server.url}/subscription/${subscriptionId}/customers/bulk`,
			body,
			{ headers }
		);
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** STATISTIQUES ABONNEMENTS */
async function getSubscriptionStats({ period = "month", startDate = null, endDate = null } = {}) {
	try {
		let results = await axios.get(`${server.url}/stats/subscriptions`, {
			headers, params: { period, startDate, endDate },
		});
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** DÉPENSES */
async function getExpenses({ page = 1, limit = 10, search = "", startDate = null, endDate = null } = {}) {
	try {
		let results = await axios.get(`${server.url}/depense`, {
			headers, params: { page, limit, search, startDate, endDate },
		});
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function createExpense(details) {
	try {
		let results = await axios.post(`${server.url}/depense`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function updateExpense(id, details) {
	try {
		let results = await axios.put(`${server.url}/depense/${id}`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function deleteExpense(id) {
	try {
		let results = await axios.delete(`${server.url}/depense/${id}`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function getExpenseStats({ period = "month", startDate = null, endDate = null } = {}) {
	try {
		let results = await axios.get(`${server.url}/depense/stats`, {
			headers, params: { period, startDate, endDate },
		});
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** STOCK */
async function getProducts({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/stock`, {
			headers, params: { page, limit, search },
		});
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function createProduct(details) {
	try {
		let results = await axios.post(`${server.url}/stock`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function updateProduct(id, details) {
	try {
		let results = await axios.put(`${server.url}/stock/${id}`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function deleteProduct(id) {
	try {
		let results = await axios.delete(`${server.url}/stock/${id}`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** FOURNISSEURS */
async function getSuppliers({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/fournisseur`, {
			headers, params: { page, limit, search },
		});
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function createSupplier(details) {
	try {
		let results = await axios.post(`${server.url}/fournisseur`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function updateSupplier(id, details) {
	try {
		let results = await axios.put(`${server.url}/fournisseur/${id}`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function deleteSupplier(id) {
	try {
		let results = await axios.delete(`${server.url}/fournisseur/${id}`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** SORTIES DE STOCK */
async function getStockExits({ page = 1, limit = 10, search = "" } = {}) {
	try {
		let results = await axios.get(`${server.url}/sortie-stock`, {
			headers, params: { page, limit, search },
		});
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function createStockExit(details) {
	try {
		let results = await axios.post(`${server.url}/sortie-stock`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function deleteStockExit(id) {
	try {
		let results = await axios.delete(`${server.url}/sortie-stock/${id}`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function getVentesStats({ period = 'month' } = {}) {
	try {
		let results = await axios.get(`${server.url}/sortie-stock/ventes`, { headers, params: { period } });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

async function createExpenseAdjustment(id, details) {
	try {
		let results = await axios.post(`${server.url}/depense/${id}/adjust`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** RAPPELS */
async function getReminders({ page = 1, limit = 10 } = {}) {
	try {
		let results = await axios.get(`${server.url}/rappel`, { headers, params: { page, limit } });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function createReminder(details) {
	try {
		let results = await axios.post(`${server.url}/rappel`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function updateReminder(id, details) {
	try {
		let results = await axios.put(`${server.url}/rappel/${id}`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function deleteReminder(id) {
	try {
		let results = await axios.delete(`${server.url}/rappel/${id}`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function archiveReminder(id) {
	try {
		let results = await axios.patch(`${server.url}/rappel/${id}/archive`, {}, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function getRemindersByRange({ startDate, endDate } = {}) {
	try {
		let results = await axios.get(`${server.url}/rappel/range`, { headers, params: { startDate, endDate } });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** CHAT */
async function getConversations() {
	try {
		let results = await axios.get(`${server.url}/chat/conversations`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function getMessages(conversationId) {
	try {
		let results = await axios.get(`${server.url}/chat/conversation/${conversationId}/messages`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function sendMessage(conversationId, text) {
	try {
		let results = await axios.post(
			`${server.url}/chat/conversation/${conversationId}/message`,
			{ text },
			{ headers }
		);
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

/** SALLES (multi-venues) */
async function getVenues() {
	try {
		let results = await axios.get(`${server.url}/salle`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function createVenue(details) {
	try {
		let results = await axios.post(`${server.url}/salle`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function updateVenue(id, details) {
	try {
		let results = await axios.put(`${server.url}/salle/${id}`, details, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}
async function deleteVenue(id) {
	try {
		let results = await axios.delete(`${server.url}/salle/${id}`, { headers });
		return results.data;
	} catch (error) { console.log(error); throw error.response.data; }
}

export default {
	changeClientStatus,
	otp,
	login,
	register,
	getSpecificUsers,
	updateInscription,
	attributionSubscription,
	createSubscription,
	deleteSubscription,
	getCustomerSubscription,
	getSingleSubscription,
	updateSubscription,
	getSubscriptions,
	createFood,
	getFoods,
	getCustomerFood,
	getFoodsAttributions,
	deleteFood,
	updateFood,
	attributeFood,
	removeAttribution,
	getFoodCategories,
	createFoodCategory,
	updateFoodCategory,
	deleteFoodCategory,
	getRewards,
	attributeReward,
	addReward,
	createProcotol,
	getCustomerProtocols,
	updateProcotol,
	singleProtocolAttribution,
	multiProtocolAttribution,
	getProtocols,
	getProtocol,
	deleteProtocol,
	endProtocol,
	getExercises,
	addExercise,
	updateExercise,
	deleteExercise,
	syncExerciseWithProtocol,
	getProtocolExercises,
	removeExerciseToProtocol,
	getClients,
	searchClients,
	getClient,
	getSponsorships,
	foodImageUpload,
	getPresences,
	getSessions,
	addSession,
	updateSession,
	deleteSession,
	getProgrammedSessions,
	attributeSession,
	deleteProgrammedSession,
	getQuestions,
	addQuestionAnswer,
	updateQuestionAnswer,
	deleteQuestionAnswer,
	createPayment,
	getTransactions,
	getClientsPaginated,
	getFoodsPaginated,
	getSubscriptionsPaginated,
	getSponsorshipsPaginated,
	getProtocolsPaginated,
	getPresencesPaginated,
	finalizeAdvance,
	createQuickCustomer,
	attributionSubscriptionEnhanced,
	attributionSubscriptionBulk,
	getSubscriptionStats,
	getExpenses,
	createExpense,
	updateExpense,
	deleteExpense,
	getExpenseStats,
	getProducts,
	createProduct,
	updateProduct,
	deleteProduct,
	getSuppliers,
	createSupplier,
	updateSupplier,
	deleteSupplier,
	getReminders,
	createReminder,
	updateReminder,
	deleteReminder,
	getConversations,
	getMessages,
	sendMessage,
	getVenues,
	createVenue,
	updateVenue,
	deleteVenue,
	getStockExits,
	createStockExit,
	deleteStockExit,
	createExpenseAdjustment,
	archiveReminder,
	getRemindersByRange,
	getVentesStats,
};
